<template>
  <div class="reports-wrap">
    <router-link
      v-if="!isIndex"
      to="/reports"
      class="view-header__btn reports-back-btn"
    >
      <i class="bi bi-arrow-left"></i>
      Volver a reportes
    </router-link>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  computed: {
    isIndex() {
      return this.$route.path === '/reports' || this.$route.path === '/reports/';
    },
  },
};
</script>

<style scoped>
.reports-wrap {
  position: relative;
}

/* Se alinea con la línea del título del header (container-fluid + view-header my-4). */
.reports-back-btn {
  position: absolute;
  top: 1.5rem;
  right: 15px;
  z-index: 3;
}

@media (max-width: 600px) {
  .reports-back-btn {
    top: 1rem;
    right: 15px;
  }
}

/* El botón de volver no debe salir en la impresión de ningún reporte. */
@media print {
  .reports-back-btn {
    display: none !important;
  }
}
</style>
